/**
 * Creates `parameters/organization` when it is missing, memoized per session.
 *
 * Consumers: `useOrganizationParameters` (fire-and-forget, its rejection is the
 * expected outcome for a non-orgsAdmin user) and every dotted-path writer —
 * `saveVisibilityLists`, `saveVisibilityDefaultsForFormType` — which MUST await
 * it, because `updateDoc` rejects on a missing document where `setDoc(merge)`
 * would have created one. A rejection clears the memo so a later attempt can
 * retry rather than inheriting a dead promise forever.
 */
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { firestore } from '../services/startFirestore';

let pending: Promise<void> | null = null;

export const ensureOrgParametersExists = (): Promise<void> => {
    if (pending) return pending;
    pending = (async () => {
        const docRef = doc(firestore, 'parameters', 'organization');
        const snap = await getDoc(docRef);
        if (!snap.exists()) {
            await setDoc(docRef, {}, { merge: true });
        }
    })().catch((error: unknown) => {
        pending = null;
        throw error;
    });
    return pending;
};
